export default {
  alreadyExists: "Already exists",
  collapse: "Collapse",
  expand: "Expand",
  remove: "Remove",
  restore: "Add again",
  regenerate: "Regenerate",
  generating: "Generating content with AI...",
  themePlaceholder:
    "E.g.: focus on sustainability, innovation, community engagement...",
  themeHint:
    "Optional theme to guide the regeneration (maximum 200 characters).",
  themeInfo:
    "Optional: write keywords or a short orientation to guide the regeneration; there is no need for long text. E.g.: “agile methodologies”, “focused on sustainability”, “collaborative work”.",
};
